import React from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerCircular } from '@weirgroup/weir-dls';
import './loading-spinner.scss';

interface LoadingSpinnerProps {
    darkMode?: boolean;
    message?: string;
    size?: 'sm' | 'md' | 'lg';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
    darkMode = false, 
    message,
    size = 'md',
}) => {
    const { t } = useTranslation();
    
    const displayMessage = message || t('loading').toString();
    
    return (
        <div className="loading-spinner-overlay">
            <div className="loading-spinner-container">
                <SpinnerCircular darkMode={darkMode} size={size} />
                <p className={`spinner-label ${darkMode ? 'dark' : 'light'}`}>
                    {displayMessage}
                </p>
            </div>
        </div>
    );
};